Ext.define('SA.VectorMapLocationLabelsLayerProperties', {
    singleton: true,

    get({isLocationLabelsEnabled}) {
        return {visible: isLocationLabelsEnabled};
    }
});